module.exports = __webpack_public_path__ + "img/img09.4d48c8cd.jpg";